import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
    RESET_PASSWORD_CONFIRM_SUCCESS,
    RESET_PASSWORD_CONFIRM_FAIL,
    SET_AUTH_LOADING,
    REMOVE_AUTH_LOADING,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    REFRESH_SUCCESS,
    REFRESH_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    LOGOUT,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL,
} from "./types"

import axios from "axios"

export const login = (username, password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    })

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({
        username, 
        password
    })

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/create/`, body, config)
        if (res.status === 200){
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data
            })

            dispatch(load_user())

            dispatch({
                type: REMOVE_AUTH_LOADING
            })
        } else{
            dispatch({
                type: LOGIN_FAIL
            })
            dispatch({
                type: REMOVE_AUTH_LOADING
            })
        }

    } catch(err){
        dispatch({
            type: LOGIN_FAIL
        })
        dispatch({
            type: REMOVE_AUTH_LOADING
        })
    }

}

export const check_aunthenticated = () => async dispatch => {
    if (localStorage.getItem('access')) {

        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        const body = JSON.stringify({
            token: localStorage.getItem('access')
        })

        try {

            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/verify/`, body, config)

            if (res.status === 200) {
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                })
            } else {
                dispatch({
                    type: AUTHENTICATED_FAIL
                })
            }

        } catch (err) {
            dispatch({
                type: AUTHENTICATED_FAIL
            })
        }


    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        })
    }
}

export const refresh = () => async dispatch => {
    if (localStorage.getItem('refresh')){

        const config = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }

        const body = JSON.stringify({
            token: localStorage.getItem('refresh')
        })

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/jwt/refresh/`, body, config)

            if (res.status === 200){
                dispatch({
                    type: REFRESH_SUCCESS,
                    payload: res.data
                })

            } else {
                dispatch({
                    type: REFRESH_FAIL
                })
            }


        } catch(err) {
            dispatch({
                type: REFRESH_FAIL
            })
        }
        
    } else {
        dispatch({
            type: REFRESH_FAIL
        })
    }
}

export const change_password = (new_password) => async dispatch => {

    const config = {
        headers: {
            'Accept': 'application/json',
            'Authorization': `JWT ${localStorage.getItem('access')}`
        }
    }

    const body = JSON.stringify({
        new_password: new_password
    })
    const res = await axios.patch(`${process.env.REACT_APP_API_URL}/auth/change_password`, body, config);
}

export const reset_password = (email) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    })

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ email })

    try {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_password/`, body, config)

        if (res.status === 204) {
            dispatch({
                type: RESET_PASSWORD_SUCCESS
            })
            
            dispatch({
                type: REMOVE_AUTH_LOADING
            })
        } else {
            dispatch({
                type: RESET_PASSWORD_FAIL
            })
            
            dispatch({
                type: REMOVE_AUTH_LOADING
            })
        }

    } catch(err){
        dispatch({
            type: RESET_PASSWORD_FAIL
        })
        
        dispatch({
            type: REMOVE_AUTH_LOADING
        })
    }
}

export const reset_password_confirm = (uid, token, new_password, re_new_password) => async dispatch => {
    dispatch({
        type: SET_AUTH_LOADING
    })

    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ 
        uid,
        token,
        new_password,
        re_new_password
     })

     if (new_password !== re_new_password){
        dispatch({
            type: RESET_PASSWORD_CONFIRM_FAIL
        })
        dispatch({
            type: REMOVE_AUTH_LOADING
        })
     } else {
        try{
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_password_confirm`, body, config)

            if (res.status === 204){
                dispatch({
                    type: RESET_PASSWORD_CONFIRM_SUCCESS
                })
                dispatch({
                    type: REMOVE_AUTH_LOADING
                })
            } else {
                dispatch({
                    type: RESET_PASSWORD_CONFIRM_FAIL
                })
                dispatch({
                    type: REMOVE_AUTH_LOADING
                })
            }
        } catch(err){
            dispatch({
                type: RESET_PASSWORD_CONFIRM_FAIL
            })
            dispatch({
                type: REMOVE_AUTH_LOADING
            }) 
        }
     }
}

export const logout = () => dispatch => {
    dispatch({
        type: LOGOUT
    })
   
}

export const load_user = () => async dispatch => {
    if (localStorage.getItem('access')) {
        const config = {
            headers: {
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        }
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/users/me/`, config)

            if (res.status === 200){
                dispatch({
                    type: USER_LOADED_SUCCESS,
                    payload: res.data
                })
            } else {
                dispatch({
                    type: USER_LOADED_FAIL
                })
            }

        } catch(err){
            dispatch({
                type: USER_LOADED_FAIL
            })
        }

        } else {
        dispatch({
            type: USER_LOADED_FAIL
        })
    }
}